// extracted by mini-css-extract-plugin
module.exports =  {"resendTimer":"resendTimer___uVxJn"};